<template>
  <p
    class="altadena-disclaimer max-w-screen-lg px-5 mx-auto text-sm italic text-center text-gray-500"
  >
    {{ text }}
  </p>
</template>

<script setup>
const text = await useAltadenaDisclaimer();
</script>
